import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Col,
  Row,
  Label,
} from "reactstrap";
import TextEditor from "components/editor/TextEditor";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useParams,useNavigate } from "react-router-dom";
import { httpRequest } from "utils/httpRequest";
import { toast } from 'react-toastify';

const AddArticle = () => {


  const [imageLink, setImageLink] = useState(null)
  

  const { id } = useParams();
  const navigate=useNavigate()






  const getArticleForEdit = async () => {
    try {

      const response = await httpRequest(
        `article/get/${id}`,
        "GET",
        {},
        {},
        true,
        false
      );
      if (response?.code === 200) {
        



        formik.resetForm({
          values: {
            title: response?.data?.title,
            description: response?.data?.description,
            image: response?.data?.image, // or null if you want fresh upload
            imagePreview: response?.data?.image // if you have a URL to show existing image
          }
        });

      }
    } catch (error) {
      console.error("Upload error:", error);
     
    }
  }

  useEffect(() => {
    if (id) {
      getArticleForEdit()
    }

  }, [id])





  // Validation Schema
  const validationSchema = Yup.object().shape({
    title: Yup.string()
      .required("Article title is required")
      .min(3, "Title must be at least 3 characters"),
    description: Yup.string()
            .required("Description is required")
            .test('not-empty-html', 'Description is required', function(value) {
              if (!value) return false;
              // Remove HTML tags and check if there's actual content
              const textOnly = value.replace(/<[^>]*>/g, '').trim();
              return textOnly.length > 0;
            }),

    image: Yup.mixed()
      .test('image-check', 'Image is required', function (value) {
        // Valid if we have either a file or an existing image path
        return value !== null && value !== undefined;
      })
      .test(
        "fileType",
        "Only image files are allowed",
        (value) => {
          // Skip validation if it's an existing image path (string)
          if (typeof value === 'string') return true;
          // Validate file type if it's a new upload
          return !value || ["image/jpeg", "image/png", "image/gif"].includes(value.type);
        }
      )
      .test(
        "fileSize",
        "Image must be smaller than 5MB",
        (value) => {
          // Skip validation if it's an existing image path
          if (typeof value === 'string') return true;
          return !value || value.size <= 5000000;
        }
      )
  });


  const formik = useFormik({
    initialValues: {
      title: "",
      description: "",
      image: null,
      imagePreview: ""
    },
    validationSchema,
    onSubmit: async (values) => {
      formik.setTouched({

        title: true,
        description: true,
        image: true
      });
      const errors = await formik.validateForm();

      if (Object.keys(errors).length > 0) return false;

      try {

        let finalImage;

        if (values.image instanceof File) {
          finalImage = await getUploadedImageLink(values.image);
        }
        // If it's a string (existing image path)
        else if (typeof values.image === 'string') {
          finalImage = values.image;
        }

        const response = await httpRequest(
          `article/update/${id}`,
          "PUT",
          {
            title: values.title,
            description: values.description,
            image: finalImage
          },
          {},
          true,
          true
        );
        if (response?.code === 200) {
          
          toast.success("Article updated successfully")
          formik.resetForm()
          navigate("/admin/article-management")

        }

      } catch (error) {
        console.log(error);
       
      }

    },
  });


  const getUploadedImageLink = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await httpRequest(
        "admin/UploadMedia",
        "POST",
        formData,
        {},
        true,
        true
      );
      return response?.filePath;
    } catch (error) {
      console.log("Upload error:", error);
      throw error;
    }
  };




  const handleImageChange = async (e) => {
    const file = e.target.files[0];

    
    if (!file) return;
    const previewUrl = URL.createObjectURL(file);

    formik.setValues({
      ...formik.values,
      image: file,
      imagePreview: previewUrl
    });


    try {
      const uploadedImageLink = await getUploadedImageLink(file); 
      setImageLink(uploadedImageLink);
    } catch (error) {
      console.log("Upload failed:", error);
    }
  };

  return (
    <Row className="mt-4 justify-content-center">
      <Col lg="8">
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent pb-3">
            <div className="text-muted text-center mt-2 mb-3">
              <small>Edit Article</small>
            </div>
          </CardHeader>
          <CardBody className="px-lg-5 py-lg-4">
            <Form onSubmit={formik.handleSubmit}>
              {/* Article Title */}
              <FormGroup className="mb-3">
                <Label className="form-control-label">Article Title</Label>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-book-bookmark" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Enter Article title"
                    type="text"
                    name="title"
                    value={formik.values.title}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </InputGroup>
                {formik.touched.title && formik.errors.title && (
                  <div className="text-danger small mt-1">
                    {formik.errors.title}
                  </div>
                )}
              </FormGroup>

              {/* Article Description */}
              <FormGroup>
                <Label className="form-control-label">Article Description</Label>
                <TextEditor
                  value={formik.values.description}
                  onChange={(html) => formik.setFieldValue("description", html)}
                  onBlur={() => formik.setFieldTouched("description", true)}
                  placeholder="Write the article description..."
                  hideImageAndLink={true}
                />
                {formik.touched.description && formik.errors.description && (
                  <div className="text-danger small mt-1">
                    {formik.errors.description}
                  </div>
                )}
              </FormGroup>

              {/* Image Upload */}
              <FormGroup className="mb-4">
                <Label className="form-control-label" htmlFor="imageUpload">
                  Upload Article Cover Image
                </Label>
                <Input
                  type="file"
                  name="image"
                  id="imageUpload"
                  accept="image/*"
                  onChange={handleImageChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.image && formik.errors.image && (
                  <div className="text-danger small mt-1">
                    {formik.errors.image}
                  </div>
                )}
              </FormGroup>
              {formik.values.imagePreview && (
                <div className="mt-3">
                  <img
                    src={
                      typeof formik.values.imagePreview === 'string' &&
                        formik.values.imagePreview.startsWith('blob:')
                        ? formik.values.imagePreview // Use blob URL directly
                        : `${process.env.REACT_APP_IMAGE_URL}${formik.values.imagePreview}` // Prepend base URL for existing images
                    }
                    alt="Preview"
                    style={{ maxWidth: "25%", height: "auto", borderRadius: "0.25rem" }}
                    onError={(e) => {
                      e.target.src = '/path/to/fallback-image.jpg'; // Add fallback
                    }}
                  />
                </div>
              )}

              <div className="text-center">
                <Button className="my-4" color="primary" type="submit">
                  Save Article
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default AddArticle;